import { Link } from "react-router-dom";
import { Seo } from "./Seo";
import { PageHero } from "./PageHero";
import { LEGAL_NAV, SITE } from "@/config/site";

export const LegalPage = ({ title, seoTitle, description, crumb, children }) => (
  <>
    <Seo title={seoTitle} description={description} />
    <PageHero crumb={crumb} eyebrow="Informations légales" title={title}>
      <p className="mt-6 text-sm text-white/60" data-testid="legal-update-date">Dernière mise à jour : {SITE.legalUpdateDate}</p>
    </PageHero>
    <section className="section bg-concrete">
      <div className="container-x grid lg:grid-cols-12 gap-12">
        <aside className="lg:col-span-3">
          <nav aria-label="Pages légales" className="card p-5 lg:sticky lg:top-28">
            <p className="text-xs font-semibold tracking-[0.18em] uppercase text-muted mb-3">Pages légales</p>
            <ul className="space-y-1">
              {LEGAL_NAV.map((l) => (
                <li key={l.to}><Link to={l.to} className={`block px-3 py-2 rounded-lg text-sm font-semibold transition-colors ${l.label === crumb ? "bg-slate text-white" : "text-slate hover:bg-concrete"}`}>{l.label}</Link></li>
              ))}
            </ul>
          </nav>
        </aside>
        {/* Modèle à faire relire par un conseil juridique avant publication. */}
        <article className="lg:col-span-9 card p-7 sm:p-12 prose-legal" data-testid="legal-content">
          {children}
        </article>
      </div>
    </section>
  </>
);
